import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { sendGoogleAnalyticsMetrics } from "../../store/actions/googleAnalytics";
import { gaEventsMap } from "./constants";

export const useTrackingHistory = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (path, isReplaceHistory = false) => {
    // Check if path is an object containing pathname and state
    let actualPath = path;
    let state = null;

    if (typeof path === "object" && path !== null) {
      if (path.pathname) {
        actualPath = path.pathname;
        state = path.state || null;
      }
    }

    dispatch(sendGoogleAnalyticsMetrics(gaEventsMap[actualPath]));
    navigate(actualPath, {
      replace: isReplaceHistory,
      state
    });
  };
};
